const accountingRoutes = [
  {
    path: '/accounting/manage-accounting',
    name: 'openInvoices',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/manage-accounting.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/transactionedit/:id',
    name: 'transactionedit',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/transaction-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/transactioncancel/:id',
    name: 'transactionecancel',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/transaction-cancel.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/newtransactionrefund/',
    name: 'transactionrefundnew',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/transaction-refund-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/edittransactionrefund/:id',
    name: 'transactionrefundedit',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/transaction-refund-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/newusercredit/',
    name: 'userCreditNew',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/user-credit-new.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/editusercredit/:id',
    name: 'userCreditEdit',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/user-credit-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/miscellaneous-invoice',
    name: 'miscellaneousInvoice',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/miscellaneous-invoice.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/additional-invoice',
    name: 'additionalInvoice',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/additional-invoice.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/accounting/group-transaction-edit',
    name: 'groupTransactionEdit',
    component: () => import(/* webpackChunkName: "accounting" */ './pages/group-transaction-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
];

export default accountingRoutes;
